import { Button } from '@repo/ui/button'
import {
	Alert,
	AlertAction,
	AlertDescription,
	AlertTitle
} from '@repo/ui/alert'
import {
	Empty,
	EmptyContent,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
	EmptyTitle
} from '@repo/ui/empty'
import { CircleAlert, LoaderCircle, RefreshCw } from 'lucide-react'
import { useTranslation } from '@/lib/i18n'

export function QueryErrorState(props: {
	message: string
	onRetry: () => void
}) {
	const { t } = useTranslation()

	return (
		<Empty className='border-0 bg-transparent'>
			<EmptyHeader>
				<EmptyMedia
					className='bg-destructive/10 text-destructive'
					variant='icon'
				>
					<CircleAlert />
				</EmptyMedia>
				<EmptyTitle>{props.message}</EmptyTitle>
				<EmptyDescription>{t('common:retry_copy')}</EmptyDescription>
			</EmptyHeader>
			<EmptyContent>
				<Button onClick={props.onRetry} variant='outline'>
					<RefreshCw />
					{t('common:retry')}
				</Button>
			</EmptyContent>
		</Empty>
	)
}

export function QueryLoadingState(props: { message: string }) {
	return (
		<Empty className='border-0 bg-transparent'>
			<EmptyHeader>
				<EmptyMedia variant='icon'>
					<LoaderCircle className='animate-spin' />
				</EmptyMedia>
				<EmptyTitle>{props.message}</EmptyTitle>
			</EmptyHeader>
		</Empty>
	)
}

export function MutationErrorAlert() {
	const { t } = useTranslation()

	return (
		<Alert variant='destructive'>
			<CircleAlert />
			<AlertTitle>{t('common:action_failed')}</AlertTitle>
			<AlertDescription>
				{t('common:action_failed_copy')}
			</AlertDescription>
		</Alert>
	)
}

export function QueryInlineError(props: {
	message: string
	onRetry: () => void
}) {
	const { t } = useTranslation()

	return (
		<Alert variant='destructive'>
			<CircleAlert />
			<AlertTitle>{props.message}</AlertTitle>
			<AlertDescription>{t('common:retry_copy')}</AlertDescription>
			<AlertAction>
				<Button onClick={props.onRetry} size='sm' variant='outline'>
					<RefreshCw />
					{t('common:retry')}
				</Button>
			</AlertAction>
		</Alert>
	)
}
